
// src/pages/BranchBalance/components/exportBranchBalanceCsv.js

const fmt = (num) =>
  Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

/**
 * @param {object} params
 * @param {Array}   params.list     - from Redux state.branchBalance.list
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportBranchBalanceCsv = ({
  list,
  title    = "Branch Balance Report",
  filename = "branch_balance",
}) => {
  const headers = [
    "No.", "Branch Name", "Branch Address",
    "Paid Amount", "Received Amount", "Balance",
  ].map(escape);

  const dataRows = list.map((row, i) => [
    i + 1,
    row.name            || "",
    row.branch_address  || "",
    fmt(row.transferAmount),
    fmt(row.receivedAmount),
    fmt(row.balance),
  ].map(escape));

  const paidTotal     = list.reduce((s, r) => s + Number(r.transferAmount || 0), 0);
  const receivedTotal = list.reduce((s, r) => s + Number(r.receivedAmount  || 0), 0);
  const balanceTotal  = list.reduce((s, r) => s + Number(r.balance         || 0), 0);

  const totalRow = [
    "Grand Total:", "", "",
    fmt(paidTotal),
    fmt(receivedTotal),
    fmt(balanceTotal),
  ].map(escape);

  const rows = [[title], [], headers, ...dataRows, [], totalRow];

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};